import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getToken } from '../helpers/Token';
import minecraftUrls from "../configs/mine_craft/minecraftUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const mineCraftApi: ApiInterface = axios.create({ baseURL: minecraftUrls.baseURL });
mineCraftApi.interceptors.request.use(onRequest);

mineCraftApi.oneSky = {
  url: minecraftUrls.remoteUrl.bind(minecraftUrls),
  uploadHeaders: {
    'Authorization': `Bearer ${getToken()}`
  }
}

export default mineCraftApi;
